export const getShapeTopParent = (shape, p) => {
  if (!shape) return shape;

  if (p === undefined || p === null) {
    p = shape.getParent();
    return getShapeTopParent(p, p)
  }

  const topParent = shape.getParent();

  if (topParent && topParent.getType() === "Group") {
    p = topParent;
    return getShapeTopParent(topParent, p);
  } else {
    return p;
  }
};


// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/getShapeTopParent.js